export default () => ({
    widgets: [],
    error: '',
    errorDublicated: '',
    excelUrl: ''
});
  